import React from 'react';
import { Input} from '@appkit4/react-components/field';

interface InputStringProps {
  value: string;
  onChange: (value: string) => void;
  title?: string;
  required?: boolean;
  type?:string;
  revealer?:boolean;
  maxLength?: number;
}

const InputString: React.FC<InputStringProps> = ({
  value,
  onChange,
  title,
  required = false,
  type,
  revealer,
  maxLength,
}) => {
  const handleChange = (newValue: string) => {
    onChange(newValue);
  };


  return (
    <div className='ap-field-demo-wrapper'>
      <Input
        type={type}
        title={title || "Input"}
        value={value}
        onChange={handleChange}
        required={required}
        revealer={revealer}
        maxLength={maxLength}
      />
    </div>
  );
}

export default InputString;
